export default __webpack_public_path__ + "static/media/crop.5aaf8f69.svg";